import { getSeasonBySlug } from '../../../../../shared/enums';
import KeystoneCharacterRankingsWidget from '../keystoneCharacterRankingsWidget';
import { t } from 'i18next';
import _ from 'lodash';
import moment from 'moment';
import { SeasonCountdownPane } from './countdownPane';
import apiService, { TGetKeystoneCharacterRankingsParams } from '../../../services/apiService';
import KeystoneActionCreator from '../../../actions/keystoneActionCreator';
import { Col } from '../../../../../../../shared/frontend/components/grid/Col';
import { Row } from '../../../../../../../shared/frontend/components/grid/Row';
import { ReactElement } from 'react';

export type TMythicPlusTopPlayersProps = {
  enabled: boolean;
  seasonSlug: string;
  region: string;
  realm?: string;
  seasonLogo?: ReactElement;
};

export function MythicPlusTopPlayers(props: TMythicPlusTopPlayersProps) {
  if (!props.enabled) {
    return null;
  }

  const season = getSeasonBySlug(props.seasonSlug);
  if (!season) {
    return null;
  }

  const isSeasonActive = moment.utc() >= season.starts.us;

  return (
    <>
      <div className="slds-m-bottom--small slds-m-top--large">
        <h2>
          <span className="rio-text-title--caps text-raiderio">{t('frontpage:section-header-top-mplus-players')}</span>
          {props.seasonLogo}
          <span className="slds-m-left--small slds-text-title--caps text-white">
            {t(`seasons:${season.slug}.name`)} {season.affix && <>({t(`seasons:${season.slug}.affix`)})</>}
          </span>
        </h2>
      </div>

      {isSeasonActive ? (
        <Row gutter={['xx-small', 'xx-small']}>
          <Col size={12} sm={6} md={4} grow className="slds-is-relative">
            <div className="slds-scrollable--x">
              <KeystoneCharacterRankingsWidget
                title={
                  <span>
                    <span className={'slds-m-right--x-small slds-avatar icon-role icon-small dps-lfg'} />
                    {t('frontpage:top-mplus-dps')}
                  </span>
                }
                season={season.slug}
                region={props.region}
                realm={props.realm || undefined}
                class="all"
                role="dps"
                faction={undefined}
                page={0}
                pageSize={6}
                compact={true}
                instanceId={`frontpage:${props.seasonSlug}:${props.region}:${props.realm}:dps`}
              />
            </div>
          </Col>
          <Col size={12} sm={6} md={4} grow className="slds-is-relative">
            <div className="slds-scrollable--x">
              <KeystoneCharacterRankingsWidget
                title={
                  <span>
                    <span className={'slds-m-right--x-small slds-avatar icon-role icon-small healer-lfg'} />
                    {t('frontpage:top-mplus-healers')}
                  </span>
                }
                season={season.slug}
                region={props.region}
                realm={props.realm || undefined}
                class="all"
                role="healer"
                faction={undefined}
                page={0}
                pageSize={6}
                compact={true}
                instanceId={`frontpage:${props.seasonSlug}:${props.region}:${props.realm}:healer`}
              />
            </div>
          </Col>
          <Col size={12} sm={6} md={4} grow className="slds-is-relative">
            <div className="slds-scrollable--x">
              <KeystoneCharacterRankingsWidget
                title={
                  <span>
                    <span className={'slds-m-right--x-small slds-avatar icon-role icon-small tank-lfg'} />
                    {t('frontpage:top-mplus-tanks')}
                  </span>
                }
                season={season.slug}
                region={props.region}
                realm={props.realm || undefined}
                class="all"
                role="tank"
                faction={undefined}
                page={0}
                pageSize={6}
                compact={true}
                instanceId={`frontpage:${props.seasonSlug}:${props.region}:${props.realm}:tank`}
              />
            </div>
          </Col>
        </Row>
      ) : (
        <SeasonCountdownPane season={season} index={0} />
      )}
    </>
  );
}

(MythicPlusTopPlayers as any).preloadComponentActions = async (props: TMythicPlusTopPlayersProps, params: any) => {
  if (!props.enabled) {
    return [];
  }

  return _.flatten(
    await Promise.all(
      ['dps', 'tank', 'healer'].map(
        (role: string) =>
          new Promise((resolve: any, reject: any) => {
            const loadParams: TGetKeystoneCharacterRankingsParams = {
              season: props.seasonSlug,
              region: props.region,
              realm: props.realm,
              class: 'all',
              role,
              faction: undefined,
              page: 0,
              pageSize: 6
            };

            apiService.getKeystoneCharacterRankings(loadParams, (err: any, data: any) => {
              if (err) {
                reject(err);
              } else {
                resolve([
                  KeystoneActionCreator.setKeystoneCharacterRankings(
                    data.rankings,
                    `frontpage:${props.seasonSlug}:${props.region}:${props.realm}:${role}`
                  )
                ]);
              }
            });
          })
      )
    )
  );
};
